// auto-generated by Typewriter template _models.tst from PortCall.EndPoints\Api\TopicCardChange\ApiTopicCardChange.cs
import S, { DataSignal } from 's-js';
import SArray, { SDataArray } from 's-array';
import TZDate from 'lib/TZDate';
import { jsonableObservable } from 'lib/jsonableObservable';
import { Comment, CommentData, CommentOptions } from 'data/models/Comment';
import { Event, EventData, EventOptions } from 'data/models/Event';
import { TopicCard, TopicCardData, TopicCardOptions } from 'data/models/TopicCard';
import { TopicCardOption, TopicCardOptionData, TopicCardOptionOptions } from 'data/models/TopicCardOption';
import { TopicCardChangeType } from 'server/enums/TopicCardChangeType';
import { TopicCardStatus } from 'server/enums/TopicCardStatus';

// TopicCardChangeData is the class that TopicCardChange serializes to/from
export interface TopicCardChangeData {
    Id : number;
	
    Card : TopicCardData | null;
    CardId : number;
    Comments : CommentData[] | null;
    Event : EventData | null;
    EventId : number;
    NewSelectedOption : TopicCardOptionData | null;
    NewSelectedOptionId : number;
    OldSelectedOption : TopicCardOptionData | null;
    OldSelectedOptionId : number;
    OriginalCommentEvent : EventData | null;
    OriginalCommentEventId : number | null;
    OriginalSelectedOption : TopicCardOptionData | null;
    OriginalSelectedOptionId : number | null;
	
    NewIsYes : boolean;
    NewStatus : TopicCardStatus;
    NewTimeEntryResponse : /* ISO8601 */ string | null;
    OldStatus : TopicCardStatus;
    OldTimeEntryResponse : /* ISO8601 */ string | null;
    OriginalIsYes : boolean;
    OriginalTimeEntryResponse : /* ISO8601 */ string | null;
    Type : TopicCardChangeType;
}

// TopicCardChangeOptions is the class which may be passed to the TopicCardChange constructor to define optional initial data values
export interface TopicCardChangeOptions {
    Id : number;
	
    Card? : TopicCardOptions | null;
    CardId? : number;
    Comments? : CommentOptions[] | null;
    Event? : EventOptions | null;
    EventId? : number;
    NewSelectedOption? : TopicCardOptionOptions | null;
    NewSelectedOptionId? : number;
    OldSelectedOption? : TopicCardOptionOptions | null;
    OldSelectedOptionId? : number;
    OriginalCommentEvent? : EventOptions | null;
    OriginalCommentEventId? : number | null;
    OriginalSelectedOption? : TopicCardOptionOptions | null;
    OriginalSelectedOptionId? : number | null;
	
    NewIsYes? : boolean;
    NewStatus? : TopicCardStatus;
    NewTimeEntryResponse? : /* ISO8601 */ string | null;
    OldStatus? : TopicCardStatus;
    OldTimeEntryResponse? : /* ISO8601 */ string | null;
    OriginalIsYes? : boolean;
    OriginalTimeEntryResponse? : /* ISO8601 */ string | null;
    Type? : TopicCardChangeType;
}

export class TopicCardChange {
    public Id : DataSignal<number>;
	
    public Card : DataSignal<TopicCard | null>;
    public CardId : DataSignal<number>;
    public Comments : SDataArray<Comment>;
    public Event : DataSignal<Event | null>;
    public EventId : DataSignal<number>;
    public NewSelectedOption : DataSignal<TopicCardOption | null>;
    public NewSelectedOptionId : DataSignal<number>;
    public OldSelectedOption : DataSignal<TopicCardOption | null>;
    public OldSelectedOptionId : DataSignal<number>;
    public OriginalCommentEvent : DataSignal<Event | null>;
    public OriginalCommentEventId : DataSignal<number | null>;
    public OriginalSelectedOption : DataSignal<TopicCardOption | null>;
    public OriginalSelectedOptionId : DataSignal<number | null>;
	
    public NewIsYes : DataSignal<boolean>;
    public NewStatus : DataSignal<TopicCardStatus>;
    public NewTimeEntryResponse : DataSignal<TZDate | null>;
    public OldStatus : DataSignal<TopicCardStatus>;
    public OldTimeEntryResponse : DataSignal<TZDate | null>;
    public OriginalIsYes : DataSignal<boolean>;
    public OriginalTimeEntryResponse : DataSignal<TZDate | null>;
    public Type : DataSignal<TopicCardChangeType>;

    constructor();
    constructor(data : TopicCardChangeOptions);
    constructor(data: TopicCardChangeOptions | null = null) {
        this.Id = jsonableObservable(S.value<number>(data && data.Id !== undefined ? data.Id : 0));
	    
        this.Card = S.value<TopicCard | null>(null);
        this.CardId = jsonableObservable(S.value<number>(data && data.CardId !== undefined ? data.CardId : 0));
        this.Comments = SArray<Comment>([]);
        this.Event = S.value<Event | null>(null);
        this.EventId = jsonableObservable(S.value<number>(data && data.EventId !== undefined ? data.EventId : 0));
        this.NewSelectedOption = S.value<TopicCardOption | null>(null);
        this.NewSelectedOptionId = jsonableObservable(S.value<number>(data && data.NewSelectedOptionId !== undefined ? data.NewSelectedOptionId : 0));
        this.OldSelectedOption = S.value<TopicCardOption | null>(null);
        this.OldSelectedOptionId = jsonableObservable(S.value<number>(data && data.OldSelectedOptionId !== undefined ? data.OldSelectedOptionId : 0));
        this.OriginalCommentEvent = S.value<Event | null>(null);
        this.OriginalCommentEventId = jsonableObservable(S.value<number | null>(data && data.OriginalCommentEventId !== undefined ? data.OriginalCommentEventId : null));
        this.OriginalSelectedOption = S.value<TopicCardOption | null>(null);
        this.OriginalSelectedOptionId = jsonableObservable(S.value<number | null>(data && data.OriginalSelectedOptionId !== undefined ? data.OriginalSelectedOptionId : null));
	    
        this.NewIsYes = jsonableObservable(S.value<boolean>(data && data.NewIsYes !== undefined ? data.NewIsYes : false));
        this.NewStatus = jsonableObservable(S.value<TopicCardStatus>(data && data.NewStatus !== undefined ? data.NewStatus : 0));
        this.NewTimeEntryResponse = jsonableObservable(S.value<TZDate | null>(data && data.NewTimeEntryResponse !== undefined ? data.NewTimeEntryResponse === null ? null : new TZDate(data.NewTimeEntryResponse) : null, TZDate.nullableEq));
        this.OldStatus = jsonableObservable(S.value<TopicCardStatus>(data && data.OldStatus !== undefined ? data.OldStatus : 0));
        this.OldTimeEntryResponse = jsonableObservable(S.value<TZDate | null>(data && data.OldTimeEntryResponse !== undefined ? data.OldTimeEntryResponse === null ? null : new TZDate(data.OldTimeEntryResponse) : null, TZDate.nullableEq));
        this.OriginalIsYes = jsonableObservable(S.value<boolean>(data && data.OriginalIsYes !== undefined ? data.OriginalIsYes : false));
        this.OriginalTimeEntryResponse = jsonableObservable(S.value<TZDate | null>(data && data.OriginalTimeEntryResponse !== undefined ? data.OriginalTimeEntryResponse === null ? null : new TZDate(data.OriginalTimeEntryResponse) : null, TZDate.nullableEq));
        this.Type = jsonableObservable(S.value<TopicCardChangeType>(data && data.Type !== undefined ? data.Type : 0));
    }

    static key(obj : TopicCardChange) {
        return obj.Id();
    }
    
    static dataKey(obj : TopicCardChangeOptions) {
        return obj.Id;
    }

    static update(obj : TopicCardChange, data : TopicCardChangeOptions) {
        S.freeze(() => {
            if (data.Id !== undefined) obj.Id(data.Id);
	        
            if (data.CardId !== undefined) obj.CardId(data.CardId);
            if (data.EventId !== undefined) obj.EventId(data.EventId);
            if (data.NewSelectedOptionId !== undefined) obj.NewSelectedOptionId(data.NewSelectedOptionId);
            if (data.OldSelectedOptionId !== undefined) obj.OldSelectedOptionId(data.OldSelectedOptionId);
            if (data.OriginalCommentEventId !== undefined) obj.OriginalCommentEventId(data.OriginalCommentEventId);
            if (data.OriginalSelectedOptionId !== undefined) obj.OriginalSelectedOptionId(data.OriginalSelectedOptionId);
	        
            if (data.NewIsYes !== undefined) obj.NewIsYes(data.NewIsYes);
            if (data.NewStatus !== undefined) obj.NewStatus(data.NewStatus);
            if (data.NewTimeEntryResponse !== undefined) obj.NewTimeEntryResponse(data.NewTimeEntryResponse === null ? null : new TZDate(data.NewTimeEntryResponse));
            if (data.OldStatus !== undefined) obj.OldStatus(data.OldStatus);
            if (data.OldTimeEntryResponse !== undefined) obj.OldTimeEntryResponse(data.OldTimeEntryResponse === null ? null : new TZDate(data.OldTimeEntryResponse));
            if (data.OriginalIsYes !== undefined) obj.OriginalIsYes(data.OriginalIsYes);
            if (data.OriginalTimeEntryResponse !== undefined) obj.OriginalTimeEntryResponse(data.OriginalTimeEntryResponse === null ? null : new TZDate(data.OriginalTimeEntryResponse));
            if (data.Type !== undefined) obj.Type(data.Type);
        });
    }
}



// WEBPACK FOOTER //
// ./server/models/TopicCardChange.ts